import { ForwardedInput } from 'hatch-components';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';

const FormMaskedInput = ({
  name,
  control,
  maskFn,
  rules,
  defaultValue,
  ...props
}) => (
  <Controller
    control={control}
    defaultValue={defaultValue}
    name={name}
    render={({ onChange, onBlur, value, name: renderName }) => (
      <ForwardedInput
        name={renderName}
        onBlur={onBlur}
        onChange={(v) => onChange(maskFn(v.target.value))}
        value={value}
        {...props}
      />
    )}
    rules={rules}
  />
);

FormMaskedInput.propTypes = {
  control: PropTypes.shape({}), // provided by react-hook-form
  defaultValue: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  maskFn: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  rules: PropTypes.shape({}),
};

FormMaskedInput.defaultProps = {
  control: {},
  defaultValue: undefined,
  rules: {},
};

export default FormMaskedInput;
